/** Brand-green offer counter next to "My Open Home" in the account menus. */
export const OpenHomeMenuBadge = ({ count }: { count: number }) =>
  count > 0 ? (
    <span
      data-testid="open-home-menu-badge"
      className="ml-auto inline-flex size-6 shrink-0 items-center justify-center rounded-full bg-brand-500 font-title text-xs font-bold text-white"
    >
      {count > 99 ? "99+" : count}
    </span>
  ) : null;
